import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín G.',
  age: 34,
  city: 'Bariloche',
  text: 'Siempre salía a caminar por los senderos cortos, pero me daba miedo mandarme a refugios más lejanos. El tomo de planificación y el de equipo me cambiaron la cabeza. Ahora armo mi mochila con criterio y me siento seguro.',
  initial: 'M'
}, {
  name: 'Carolina M.',
  age: 42,
  city: 'Mendoza',
  text: 'Me destrozaba las rodillas en las bajadas. Literalmente volvía llorando. Apliqué las técnicas del Tomo 3 y el uso correcto de bastones y es un antes y un después. Ya estoy planeando mi próxima salida a Vallecitos.',
  initial: 'C'
}, {
  name: 'Diego R.',
  age: 29,
  city: 'Córdoba',
  text: 'Fui al Champaquí el año pasado y la pasé pésimo por llevar cosas inútiles y ropa de algodón. Compré el pack para no repetir el error. La progresión de entrenamiento de 8 semanas es oro puro.',
  initial: 'D'
}, {
  name: 'Lucía F.',
  age: 38,
  city: 'Buenos Aires',
  text: 'Entreno en la ciudad pero la montaña me pasaba factura. Entender cómo entrenar la fuerza específica y la resistencia para el desnivel me ayudó muchísimo para mi viaje al Chaltén. Súper recomendado.',
  initial: 'L'
}, {
  name: 'Sebastián P.',
  age: 51,
  city: 'Neuquén',
  text: 'Excelente material. Muy claro, sin palabras raras. Te dice exactamente qué hacer, qué comprar y qué no. El checklist de seguridad ya lo tengo impreso y plastificado en mi mochila.',
  initial: 'S'
}];
export function Testimonials() {
  return <section className="py-20 bg-trek-blackLight border-y border-trek-brown/30" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="text-4xl sm:text-5xl font-display text-white mb-4" data-id="element-126">
            LO QUE DICEN LOS QUE{' '}
            <span className="text-trek-orange" data-id="element-127">YA EMPEZARON</span>
          </h2>
          <p className="text-trek-beige text-lg" data-id="element-128">
            Trekkers de todo el país ya están mejorando sus salidas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-129">
          {testimonials.map((t, idx) => <div key={idx} className={`bg-trek-black p-6 rounded-2xl border border-trek-brown/50 hover:border-trek-orange/50 transition-colors ${idx === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${idx === 4 ? 'md:col-span-2 lg:col-span-2 lg:w-1/2 lg:mx-auto' : ''}`} data-id="element-130">
              <div className="flex items-center gap-4 mb-4" data-id="element-131">
                <div className="w-12 h-12 rounded-full bg-trek-brown flex items-center justify-center text-trek-orange font-display text-xl" data-id="element-132">
                  {t.initial}
                </div>
                <div data-id="element-133">
                  <h4 className="text-white font-bold" data-id="element-134">{t.name}</h4>
                  <p className="text-trek-beige/60 text-sm" data-id="element-135">
                    {t.age} años • {t.city}
                  </p>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-136">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-trek-orange text-trek-orange" data-id="element-137" />)}
              </div>
              <p className="text-trek-beige leading-relaxed italic" data-id="element-138">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}